export function parseVideoUrl(url = '') {
  const yt = url.match(/(?:youtube\.com\/(?:watch\?[^#]*v=|shorts\/|embed\/)|youtu\.be\/)([\w-]{6,})/);
  if (yt) {
    return { platform: 'youtube', id: yt[1], isShort: /shorts\//.test(url) };
  }
  const ig = url.match(/instagram\.com\/(reel|reels|p)\/([\w-]+)/);
  if (ig) {
    return { platform: 'instagram', id: ig[2], kind: ig[1] === 'p' ? 'post' : 'reel', isShort: true };
  }
  if (url.includes('instagram.com')) {
    return { platform: 'instagram', id: null, kind: 'profile', isShort: true };
  }
  return null;
}

export const ytThumb = (id) => `https://i.ytimg.com/vi/${id}/hqdefault.jpg`;

export const ytEmbed = (id) =>
  `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&modestbranding=1`;

export const igEmbed = (video) =>
  `https://www.instagram.com/${video.kind === 'post' ? 'p' : 'reel'}/${video.id}/embed`;
